import { create } from 'zustand';

interface ScoreBreakdownState {
  scoreBreakdownRow: any;
  setScoreBreakdownRow: (row: any) => void;
}

export const useScoreBreakdownStore = create<ScoreBreakdownState>()(set => ({
  scoreBreakdownRow: null,
  setScoreBreakdownRow: row => set({ scoreBreakdownRow: row }),
}));
